import { date, field, readonly } from '@nozbe/watermelondb/decorators'

import { Model } from '@nozbe/watermelondb'

export const modelToDTOMapping = {
  identical: ['timestamp', 'level', 'category', 'action', 'payload'],
  references: [
    {
      dtoName: 'userId',
      modelName: 'user_id',
    },
    {
      dtoName: 'farmId',
      modelName: 'farm_id',
    },
    {
      dtoName: 'deviceId',
      modelName: 'device_id',
    },
  ],
}

export default class Events extends Model {
  static table = 'events'

  @field('id') id
  @readonly @date('created_at') createdAt
  @readonly @date('updated_at') updatedAt
  @field('isDeleted') isDeleted
  @field('priority') priority

  @field('timestamp') timestamp
  @field('level') level
  @field('category') category
  @field('action') action
  @field('payload') payload

  @field('user_id') userId
  @field('farm_id') farmId
  @field('device_id') deviceId
}
